package com.tovtalk.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clipToBounds
import com.tovtalk.ui.adaptive.LocalWindowSizeClass
import com.tovtalk.ui.adaptive.WindowSizeClass
import com.tovtalk.ui.adaptive.isMobile

@Composable
fun AdaptiveScaffold(
    items: List<NavigationItem>,
    selectedRoute: String,
    onItemClick: (NavigationItem) -> Unit,
    bottomItems: List<NavigationItem> = emptyList(),
    bottomBar: @Composable () -> Unit = {},
    navigationRailContent: @Composable () -> Unit = {
        TovTalkNavigationRail(
            items = items,
            selectedRoute = selectedRoute,
            onItemClick = onItemClick,
            bottomItems = bottomItems,
        )
    },
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    val windowSizeClass = LocalWindowSizeClass.current

    when {
        // Compact + MediumCompact: Bottom Bar
        windowSizeClass == WindowSizeClass.Compact ||
        windowSizeClass == WindowSizeClass.MediumCompact -> {
            // Video stops above the bottom bar – bar never covers content
            Column(modifier = modifier.fillMaxSize()) {
                Box(modifier = Modifier.weight(1f).fillMaxWidth().clipToBounds()) {
                    content()
                }
                bottomBar()
            }
        }
        // Medium+ (Rail or Drawer — same Row structure;
        // NavigationRail itself decides compact rail vs permanent drawer via hasDrawer())
        else -> {
            Row(modifier = modifier.fillMaxSize()) {
                navigationRailContent()
                Box(modifier = Modifier.weight(1f).fillMaxHeight().clipToBounds()) {
                    content()
                }
            }
        }
    }
}
